import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g id="Layer_1-2">
        <path
          id="Path_1723"
          fill="#eaf3fe"
          d="M11.93,0c6.59,0,11.93,5.34,11.93,11.93s-5.34,11.93-11.93,11.93S0,18.52,0,11.93,5.34,0,11.93,0Z"
        />
        <path
          fill="#187ae8"
          d="M13.6,4.55c.08,.02,.16,.04,.23,.06,1.03,.24,1.63,1.34,1.23,2.28-.26,.62-.75,.98-1.41,1.07-.75,.11-1.38-.13-1.84-.74-.58-.78-.33-1.89,.56-2.4,.22-.13,.49-.18,.73-.27,.16,0,.33,0,.49,0Z"
        />
        <path
          fill="#187ae8"
          d="M14.99,17.71c-.07,.27-.12,.52-.19,.77-.01,.04-.05,.08-.09,.1-.55,.2-1.09,.44-1.65,.59-.79,.21-1.59,.23-2.35-.14-.7-.34-1.06-.92-1.06-1.71,0-.64,.16-1.26,.33-1.88,.28-.99,.54-1.98,.8-2.97,.09-.33,.11-.68,.05-1.03-.06-.3-.22-.48-.52-.54-.41-.09-.8-.05-1.19,.07-.14,.04-.28,.09-.45,.15,.07-.28,.13-.54,.2-.79,0-.03,.05-.06,.08-.07,.66-.25,1.32-.53,2.02-.66,.68-.12,1.36-.1,2,.21,.67,.33,1.03,1.04,1,1.79-.04,1.01-.39,1.94-.64,2.9-.16,.63-.34,1.26-.49,1.89-.07,.31-.12,.63-.05,.96,.08,.38,.25,.53,.64,.6,.49,.08,.95-.02,1.41-.18,.04-.02,.09-.03,.16-.06Z"
        />
      </g>
    </svg>
  )
}

type InfoIconOutlineProps = SvgIconProps

export const InfoIconOutline: React.FC<InfoIconOutlineProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 23.86 23.86" focusable="false" aria-hidden="true" />
}
